const NavNews = (props) => {
  return (
    <svg {...props} viewBox="0 0 19 25">
      <path
        d="M12.2217 19.4487V23.7323C12.3691 23.6303 12.5146 23.5254 12.6314 23.4076L17.1703 18.8687C17.2881 18.7519 17.393 18.6074 17.495 18.459H13.2114C12.6661 18.459 12.2217 18.9034 12.2217 19.4487Z"
        fill={props?.svgfill || "#1F2933"}
      />
      <path
        d="M6.28342 6.08691H4.79883V7.57151H6.28342V6.08691Z"
        fill={props?.color || "#01337d"}
      />
      <path
        d="M16.1813 0.643555H2.32516C1.23349 0.643555 0.345703 1.53035 0.345703 2.62301V22.4176C0.345703 23.5102 1.23349 24.397 2.32516 24.397H10.243V19.4484C10.243 17.8114 11.5752 16.4792 13.2122 16.4792H18.1608V2.62301C18.1608 1.53035 17.273 0.643555 16.1813 0.643555ZM7.2738 18.4587H3.31489V16.4792H7.2738V18.4587ZM13.2122 14.4997H3.31489V12.5203H13.2122V14.4997Z"
        fill={props?.color || "#01337d"}
      />
      <path
        d="M3.34277 3.81055V10.2305H6.28277C7.35277 10.2305 7.75277 9.74055 7.75277 8.99055V8.03055C7.75277 7.52055 7.66277 7.17055 7.27277 7.00055C7.66277 6.79055 7.75277 6.39055 7.75277 5.87055V5.05055C7.75277 4.30055 7.35277 3.81055 6.28277 3.81055H3.34277ZM6.03277 8.86055C6.03277 9.01055 5.95277 9.08055 5.78277 9.08055H5.06277V7.59055H5.78277C5.95277 7.59055 6.03277 7.66055 6.03277 7.81055V8.86055ZM6.03277 6.22055C6.03277 6.37055 5.95277 6.44055 5.78277 6.44055H5.06277V4.96055H5.78277C5.95277 4.96055 6.03277 5.03055 6.03277 5.18055V6.22055ZM11.629 3.81055V7.24055L10.199 3.81055H8.69902V10.2305H10.299V6.86055L11.729 10.2305H13.2291V3.81055H11.629Z"
        fill={props?.stroke || "white"}
      />
    </svg>
  );
};
export default NavNews;
